import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

/** Custom property carrying the height of the fixed breadcrumb bar, read by the layout. */
const PAGE_HEADER_HEIGHT = '--page-header-height';

@Component({
  selector: 'app-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss']
})
export class PageContentComponent implements AfterViewInit, OnDestroy {
  @Input() showBreadcrumb = true;

  private breadcrumbBar: HTMLElement;
  private breadcrumbBarObserver: ResizeObserver;

  @ViewChild('breadcrumbBar') set breadcrumbBarRef(ref: ElementRef<HTMLElement>) {
    this.breadcrumbBar = ref?.nativeElement;
    this.observeBreadcrumbBar();
  }

  ngAfterViewInit(): void {
    this.observeBreadcrumbBar();
  }

  ngOnDestroy(): void {
    this.breadcrumbBarObserver?.disconnect();
    // the next routed page publishes its own height; leaving ours behind would make a
    // page without a breadcrumb bar look like it still had one.
    document.documentElement.style.removeProperty(PAGE_HEADER_HEIGHT);
  }

  // The breadcrumb bar is `position: fixed`, so anything the layout renders above the
  // routed page can only clear it by knowing how tall it currently is. That height is not
  // constant: the bar carries trailing actions and the breadcrumb wraps on narrow screens.
  private observeBreadcrumbBar(): void {
    this.breadcrumbBarObserver?.disconnect();

    if (!this.breadcrumbBar) {
      document.documentElement.style.removeProperty(PAGE_HEADER_HEIGHT);
      return;
    }

    if (typeof ResizeObserver === 'undefined') {
      this.publishBreadcrumbBarHeight();
      return;
    }

    this.breadcrumbBarObserver = new ResizeObserver(() => this.publishBreadcrumbBarHeight());
    this.breadcrumbBarObserver.observe(this.breadcrumbBar);
  }

  private publishBreadcrumbBarHeight(): void {
    const height = this.breadcrumbBar?.offsetHeight ?? 0;
    document.documentElement.style.setProperty(PAGE_HEADER_HEIGHT, `${height}px`);
  }
}
